import * as React from 'react';
import { useContext, useState } from 'react';
import { MyContext } from '../../context/MyContext';
import { useHistory } from 'react-router-dom';
import './loginform.css';
import { Button } from 'tabler-react';

function LoginPage() {
    const { loginUser } = useContext(MyContext);
    const history = useHistory();

    const initialState = {
        userInfo: {
            mobilenumber: '',
            password: ''
        },
        errorMsg: '',
        successMsg: ''
    };

    const [state, setState] = useState(initialState);
    const [wrongpassmsg, setWrongpassmsg] = useState('');
    const [flag, setFlage] = useState(true);

    // On change input value (email & password)
    const onChangeValue = (e) => {
        setState({
            ...state,
            userInfo: {
                ...state.userInfo,
                [e.target.name]: e.target.value
            }
        });
    };
    // On Submit Login From
    const submitForm = async (form) => {
        // console.log(form);
        const data = await loginUser(form);
        // console.log(data, 'login submit response');
        if (data.success) {
            setState({
                ...initialState
            });

            if (history.location.pathname === '/login') history.replace('/');
        } else {
            setState({
                ...state,
                successMsg: '',
                errorMsg: data.error
            });
            setWrongpassmsg(' Enter correct password !');
        }
    };

    // Show Message on Error or Success

    // let successMsg = '';
    // let errorMsg = '';
    // if (state.errorMsg) {
    //     errorMsg = <div className="error-msg">{state.errorMsg}</div>;
    // }
    // if (state.successMsg) {
    //     successMsg = <div className="success-msg">{state.successMsg}</div>;
    // }

    return (
        <div className="loginpagecontent">
            <div className="logodiv">
                <img src="./images/kmit_sanjaya_logo.png" className="logo mb-4" alt="logo" />
            </div>
            <div id="form">
                <h4 id="headerTitle">Login to your Account</h4>
                <div>
                    <div className="loginrow form-group">
                        <label className="form-label">Mobile Number</label>
                        <input
                            id="mobilenumber"
                            className="form-control"
                            type="text"
                            name="mobilenumber"
                            placeholder="Enter your mobile number"
                            onChange={(e) => {
                                setWrongpassmsg('');
                                onChangeValue(e);
                                if (/^[0]?[6789]\d{9}$/.test(e.target.value)) {
                                    document.getElementById('error').innerText =
                                        '';
                                    document
                                        .getElementById('mobilenumber')
                                        .classList.remove('is-invalid');
                                    document
                                        .getElementById('mobilenumber')
                                        .classList.add('is-valid');
                                    state.userInfo.password === ''
                                        ? setFlage(true)
                                        : setFlage(false);
                                } else {
                                    document.getElementById('error').innerText =
                                        'Enter a valid mobile number';
                                    document
                                        .getElementById('mobilenumber')
                                        .classList.remove('is-valid');
                                    document
                                        .getElementById('mobilenumber')
                                        .classList.add('is-invalid');
                                    setFlage(true);
                                }
                            }}
                        />
                        <div id="error"></div>
                    </div>
                    <div className="loginrow form-group">
                        <label className="form-label">Password</label>
                        <input
                            className="form-control"
                            type="password"
                            name="password"
                            placeholder="Enter your password"
                            onChange={(e) => {
                                setWrongpassmsg('');
                                onChangeValue(e);
                                e.target.value === ''
                                    ? setFlage(true)
                                    : setFlage(false);
                            }}
                        />
                    </div>
                    <div id="button" className="loginrow">
                        <Button
                            onClick={() => {
                                // console.log('clicked');
                                submitForm(state.userInfo);
                            }}
                            color="primary"
                            className="mt-4 loginBtn"
                            disabled={flag}
                        >
                            Log in
                        </Button>
                    </div>
                    <div className="msg1"> {wrongpassmsg} </div>
                    {/* <div className="msg1"> {errorMsg} </div> */}
                    {/* <div className="msg1"> {successMsg} </div> */}
                    <div className="loginrow">
                        <a
                            style={{
                                textDecoration: 'none',
                                textAlign: 'center'
                            }}
                            href="/sanjaya-web/forgotpassword"
                        >
                            Forgot Password ?
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LoginPage;
